import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Box,
  Typography,
  Grid,
  Paper,
  useTheme,
} from "@mui/material";
import {
  AccountBalance,
  Send,
  AddCircleOutline,
  History,
} from "@mui/icons-material";
import SendMoneyModal from "./SendMoneyModal";

const ActionBox = ({ label, icon, bg, iconBg, onClick, to }) => {
  const Wrapper = to ? RouterLink : React.Fragment;
  const wrapperProps = to
    ? { to, style: { textDecoration: "none", flex: 1, display: "flex" } }
    : {};

  return (
    <Wrapper {...wrapperProps}>
      <Box
        onClick={onClick}
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          height: "100%",
          backgroundColor: bg,
          borderRadius: 3,
          textAlign: "center",
          p: { xs: 2, md: 2.5 },
          minHeight: { xs: 100, md: 130 },
          transition: "transform 0.2s ease",
          cursor: onClick || to ? "pointer" : "default",
          "&:hover": {
            transform: onClick || to ? "scale(1.03)" : "none",
          },
        }}
      >
        <Box
          sx={{
            backgroundColor: iconBg,
            borderRadius: "50%",
            width: { xs: 36, md: 40 },
            height: { xs: 36, md: 40 },
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 1.5,
          }}
        >
          {icon}
        </Box>
        <Typography
          variant="body2"
          fontWeight="medium"
          sx={{
            fontSize: { xs: "0.75rem", md: "0.85rem" },
            color: "text.primary",
          }}
        >
          {label}
        </Typography>
      </Box>
    </Wrapper>
  );
};

const QuickActionsWidget = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const [openModal, setOpenModal] = useState(false);

  return (
    <>
      <Paper
        elevation={0}
        sx={{
          px: { xs: 2, md: 3 },
          pt: 2,
          mt: "10%",
          pb: 2,
          borderRadius: 3,
          mb: { xs: 2, md: 5 },
          width: "100%",
        }}
      >
        <Typography
          variant="h6"
          fontWeight="bold"
          gutterBottom
          sx={{ fontSize: { xs: "1rem", md: "1.1rem" } }}
        >
          What would you like to do today?
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          mb={2}
          sx={{ fontSize: { xs: "0.85rem", md: "0.9rem" } }}
        >
          Choose from our popular actions below
        </Typography>

        <Grid container spacing={2} >
          {/* Account Info */}
          <Grid item xs={6} sx={{ display: "flex", width: "44%" }}>
            <ActionBox 
              to="/local-transfer"
              label="Account Info"
              icon={<AccountBalance sx={{ color: "text.primary" }} />}
              bg={isDark ? "#1f2937" : "#f3f4f6"}
              iconBg={isDark ? "#374151" : "#e5e7eb"}
            />
          </Grid>

          {/* Send Money */}
<Grid item xs={6} sx={{ display: "flex", width: "44%" }}>
            <ActionBox
           //   to="/local-transfer"
              label="Send Money"
              icon={<Send sx={{ color: "text.primary" }} />}
              bg={isDark ? "#1e40af" : "#bae6fd"}
              iconBg={isDark ? "#1d4ed8" : "#7dd3fc"}
              onClick={() => setOpenModal(true)}
            />
          </Grid>

          {/* Deposit */}
          <Grid item xs={6} sx={{ display: "flex", width: "44%" }}>
            <ActionBox
              to="/deposits"
              label="Deposit"
              icon={<AddCircleOutline sx={{ color: "text.primary" }} />}
              bg={isDark ? "#064e3b" : "#d1fae5"}
              iconBg={isDark ? "#065f46" : "#6ee7b7"}
            />
          </Grid>

          {/* History */}
          <Grid item xs={6} sx={{ display: "flex", width: "44%" }}>
            <ActionBox
              label="History"
              icon={<History sx={{ color: "text.primary" }} />}
              bg={isDark ? "#581c87" : "#e9d5ff"}
              iconBg={isDark ? "#6b21a8" : "#d8b4fe"}
              to="/transactions"
            />
          </Grid>
        </Grid>
      </Paper>

      {/* Send Money Modal */}
      <SendMoneyModal open={openModal} handleClose={() => setOpenModal(false)} />
    </>
  );
};

export default QuickActionsWidget;